import { render, staticRenderFns } from "./BotaoAvancar.vue?vue&type=template&id=437d49ea&"
import script from "./BotaoAvancar.vue?vue&type=script&lang=js&"
export * from "./BotaoAvancar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports